import { Subject } from 'rxjs'
import { IOrder } from 'types/order'

const OrderChangeObservable = new Subject<IOrder>()

export { OrderChangeObservable }
